import React from 'react';
import classes from "./GameModal.module.css"
import LoaderSpinner from './LoaderSpinner';
import BlackModalBg from './BlackModalBg';

interface GameModalType {
  title?: string;
  body?: string;
  onClickNo ?: () => void;
  onClickYes ?: () => void;
}



const GameModal: React.FC<GameModalType> = ({ title, body, onClickNo, onClickYes }) => {

 

  return (
    <BlackModalBg>
      <div data-aos="flip-left" className={classes["modal-root-bg"]}>
        <div className={classes["modal-spinner-div"]}>
          {/* <LoaderSpinner /> */}
        </div>
        <div className={classes["modal-title"]}>{title || "Attention!!!"}</div>
        <div className={classes["modal-body"]}>
          {body?.slice(0, 180)}
      
          {onClickYes && <span> Do you still want to continue</span> }
        </div>
        <div className={classes["modal-btn"]}>
         {onClickNo &&  <button onClick={onClickNo} id={classes["modal-btn"]}>No</button>}
        {onClickYes && <button onClick={onClickYes} id={classes["modal-btn"]}>Yes</button>}
        </div>
        
      </div>
    </BlackModalBg>
  );
}


export default GameModal;